export const calculadoraDeDescontosDoMorarLegal = {
  methods: {
    calcularDescontoDeParcelas(parcelasSelecionadas, totalDeParcelasAtrasadas) {
      if (parcelasSelecionadas.length < 4
            && parcelasSelecionadas.length !== totalDeParcelasAtrasadas) {
        return 0;
      } else if (parcelasSelecionadas.length === totalDeParcelasAtrasadas) {
        return this.calcularDescontosComCemPorCentoSobreJurosEMulta(parcelasSelecionadas);
      } else if (parcelasSelecionadas.length >= 4) {
        return this.calcularDescontosComSessentaPorCentoSobreJurosEMulta(parcelasSelecionadas);
      }
      return 0;
    },
    calcularDescontosComCemPorCentoSobreJurosEMulta(parcelasSelecionadas) {
      let totalDeDesconto = 0;
      parcelasSelecionadas.forEach((parcela) => {
        totalDeDesconto += (parcela.Mora + parcela.Multa);
      });
      return totalDeDesconto;
    },
    calcularDescontosComSessentaPorCentoSobreJurosEMulta(parcelasSelecionadas) {
      let totalDeMoraEMulta = 0;
      parcelasSelecionadas.forEach((parcela) => {
        totalDeMoraEMulta += (parcela.Mora + parcela.Multa);
      });
      return totalDeMoraEMulta * 0.6;
    },
  },
};

export default calculadoraDeDescontosDoMorarLegal;
